import React from 'react';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import Thumbnail from '../chat/chat-document-thumbnail';
import WaitingIndicator from '../general-components/waiting-indicator';

interface SortablePageProps {
	id: string;
	index: number;
	thumbnailUrl?: string;
	disabled: boolean;
	notCreator: boolean;
	isUploading: boolean;
	uploadingLabel: string;
	fill?: boolean;
	backgroundColor?: string;
	selected: boolean;
	hovering: boolean;
	canDelete: boolean;
	onClickPage: () => void;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
	onDelete: () => void;
	thumbRef: (ref: HTMLDivElement | null) => void;
}

export default function SortablePage({
	id, index, thumbnailUrl, disabled, notCreator, isUploading, uploadingLabel,
	fill, backgroundColor, selected, hovering, canDelete, onClickPage,
	onMouseEnter, onMouseLeave, onDelete, thumbRef,
}: SortablePageProps) {
	const {
		attributes, listeners, setNodeRef, transform, transition, isDragging,
	} = useSortable({ id, disabled });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? 0 : 1,
	};

	return (
		<div
			className={classNames('page', notCreator && 'not-creator')}
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...listeners}
		>
			<div className={classNames('thumbnail')}
				id={`thumbnail${index}`}
				onClick={onClickPage}
				ref={thumbRef}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}>
				{isUploading
					? (
						<div className="attachment-waiting">
							{!!uploadingLabel && (
								<span>{uploadingLabel}</span>
							)}
							<WaitingIndicator />
						</div>
					) : (
						<div
							className={classNames('thumbnail-container', fill && 'fill')}
							style={{ background: backgroundColor }}
						>
							<Thumbnail thumbnail={thumbnailUrl} />
						</div>
					)
				}

				{selected && <div className="selected" />}

				{hovering && <div className="hover-gradient" />}

				{canDelete && hovering
					&& <div className="trash" onClick={onDelete}>
						<Icon name={ICONS.TRASH} color={COLORS.WHITE} size={20} />
					</div>
				}
			</div>
		</div>
	);
}
